import Button from '@atoms/Button/Button';
import Icon from '@atoms/Icon/Icon';
import Modal from '@atoms/Modal/Modal';
import Text from '@atoms/Text/Text';
import SiteEnum from '@models/enums/SiteEnum';

export interface IModalLabels {
  readonly closeLabel?: string;
  readonly buttonLabel?: string;
  readonly description?: string;
  readonly title: string;
}
interface Props {
  labels: IModalLabels;
  isOpen: boolean;
  onButtonClick?: () => void;
  onClose: () => void;
  restoreFocusRef: React.RefObject<HTMLButtonElement | null>;
  setIsOpen: (state: boolean) => void;
  site: SiteEnum;
}
const TextModal = ({
  isOpen,
  labels,
  onButtonClick,
  onClose,
  restoreFocusRef,
  setIsOpen,
  site,
}: Readonly<Props>) => (
  <Modal
    isOpen={isOpen}
    setIsOpen={setIsOpen}
    restoreFocusRef={restoreFocusRef}
  >
    <div className="tw-col-span-full tw-flex tw-h-screen tw-items-center tw-justify-center">
      <div className="tw-relative tw-flex tw-w-[343px] tw-flex-col tw-gap-sm tw-bg-grey-10 tw-p-xs md:tw-w-[560px]">
        <button
          type="button"
          aria-controls="page-modal"
          aria-label={labels.closeLabel || 'Close'}
          onClick={onClose}
          className="tw-absolute tw-right-4 tw-top-4 tw-z-10 tw-flex"
        >
          <Icon className="tw-text-black" name="cross" />
        </button>
        <Text variant="body-14-semibold">{labels.title}</Text>
        {labels.description && (
          <Text variant="body-small">{labels.description}</Text>
        )}
        <div className="tw-ml-auto tw-mt-auto">
          {labels.buttonLabel && (
            <Button
              onClick={onButtonClick}
              variant={site === SiteEnum.B2B ? 'yellow' : 'grey80'}
              label={labels.buttonLabel}
            />
          )}
        </div>
      </div>
    </div>
  </Modal>
);

export default TextModal;
